export enum FormAction {
  Add = 'Add',
  Update = 'Update'
}

export enum TableAction {
  ELIMINAR = 'Eliminar',
  MODIFICAR = 'Modificar'
}
